"use client";

import type { ComponentProps, MouseEvent, SyntheticEvent } from "react";
import { useRouter } from "next/navigation";
import { contextualizeClosestAnchor } from "./contextual-link";

type NavigationBoundaryProps = Pick<
  ComponentProps<"div">,
  | "onClickCapture"
  | "onContextMenuCapture"
  | "onFocusCapture"
  | "onPointerDownCapture"
>;

function contextualize(event: SyntheticEvent<HTMLElement>): void {
  contextualizeClosestAnchor(event.target);
}

export function useContextualNavigationBoundary(): NavigationBoundaryProps {
  const router = useRouter();
  const openLink = (event: MouseEvent<HTMLElement>) => {
    const anchor = contextualizeClosestAnchor(event.target);
    if (
      !anchor ||
      anchor.dataset.contextualLink !== undefined ||
      anchor.hasAttribute("download") ||
      anchor.target === "_blank" ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }
    const href = anchor.getAttribute("href");
    if (!href) return;
    event.preventDefault();
    router.push(href);
  };

  return {
    onClickCapture: openLink,
    onContextMenuCapture: contextualize,
    onFocusCapture: contextualize,
    onPointerDownCapture: contextualize,
  };
}
